import styled from 'styled-components';

export const MainMod = styled.main`
  height: 100vh;
  background-color: ${props => props.theme.colors.bgrSection};
`;
